import { useMemo } from "react";
import EvalGraphsResults from "./EvalGraphsResults"
import { containerResulInfo, 
         //containerResultInfoGraf,
         convertDesviacionToString } from "../helpers/ResultsHelpers";

type InfoResultsPerformanceModelProps={
  name:string
  infoEval:{
    pesoAuto: string;
    pesoLider: string;
    pesoColega: string;
    pesoSubordinado: string;
    pesoCliente: string;
    typeEval: string;
    calEsperada: string;
    result: number;
    minReq: number;
    caliForWeightByCompetence: number;
    CalificationByCompetence: number;
    desviacionByCompetence: number;
    nivel: string;
  }[]
  numberCompetencies:number
}

const InfoResultsPerformanceModel = ({infoEval,numberCompetencies}:InfoResultsPerformanceModelProps) => {
  const order = ["autoevaluacion", "lider", "colega", "subordinado", "cliente"];
  
  const evaluatedResults = useMemo(() => {    
      const calculateEvaluation = (evaluation: any): number => {        
        if (evaluation.result >= evaluation.minReq) {
          return 100;
        } else {
          return Number(((evaluation.result / evaluation.minReq) * 100));
        }
      };

  const evaluatedResults=  infoEval.map(infoEval => ({
        ...infoEval,
        resultCompetenceIndividual: calculateEvaluation(infoEval)
    }));    
    return evaluatedResults 

}, [infoEval]);

const sortedInfoEval = [...evaluatedResults].sort((a:any, b:any) => order.indexOf(a.typeEval) - order.indexOf(b.typeEval));

const getAutoEvaluacionResult = (sortedInfoEval: any[]) => {
  const hasAutoEvaluacion = sortedInfoEval.some((item) => item.typeEval === 'autoevaluacion');

  if (hasAutoEvaluacion) {
    const autoevaluacion = sortedInfoEval.find((item) => item.typeEval === 'autoevaluacion');
    if (autoevaluacion) {
      return parseFloat(autoevaluacion.resultCompetenceIndividual.toFixed(3)).toFixed(2);
    }
  }

  return '0.00';
  }

 const getPesoByTypeEval = (typeEval: string): string | undefined => {
  const item = sortedInfoEval.find(entry => entry.typeEval === typeEval);
  if (item) {
      switch (typeEval) {
          case "autoevaluacion":
              return item.pesoAuto;
          case "lider":
              return item.pesoLider;
          case "colega":
              return item.pesoColega;
          case "subordinado":
              return item.pesoSubordinado;
          case "cliente":
              return item.pesoCliente;
          default:
              return undefined;
      }
  }
  return undefined;
};

const sumResultsAndCount = (data: Array<{ [key: string]: any }>): { sum: number, count: number } => {
  const filteredData = data.filter(item => {
      switch (item.typeEval) {
          case 'autoevaluacion':
              return Number(item.pesoAuto) > 0;
          case 'lider':
              return Number(item.pesoLider) > 0;
          case 'colega':
              return Number(item.pesoColega) > 0;
          case 'subordinado':
              return Number(item.pesoSubordinado) > 0;
          case 'cliente':
              return Number(item.pesoCliente) > 0;
          default:
              return false;
      }
  });
  const sum = filteredData.reduce((total, item) => total + item.resultCompetenceIndividual, 0);
  const count = filteredData.length;  
  return { sum, count };
};
const res=sumResultsAndCount(sortedInfoEval)
const resTxt=convertDesviacionToString(sortedInfoEval[0].CalificationByCompetence.toFixed(2))


 return (
     <div className="containerResultsInfo">      
      {/* <div className="containerResulInfo"> */}
      <div className={containerResulInfo(resTxt)}>
         <div className="infoResModelEval"> 
            <div><span className="txtInfoResModelEval">Peso</span></div>  
            <div><span className="calfInfoResModelEval">{(100/numberCompetencies).toFixed(2)}%</span></div>    
        </div>
        <div className="infoResModelEval"> 
            <div><span className="txtInfoResModelEval">Auto.</span></div>  
             <div><span className="calfInfoResModelEval">{getAutoEvaluacionResult(sortedInfoEval)}</span></div>                
        </div>
         
        <div className="infoResModelEval"> 
            <div><span className="txtInfoResModelEval">Mínima esperada.</span></div>  
             <div><span className="calfInfoResModelEval">{sortedInfoEval[0].calEsperada}</span></div>               
        </div>
        <div className="infoResModelEval">             
            <div><span className="txtInfoResModelEval">Evaluación.</span></div>  
             <div><span className="calfInfoResModelEvalFin">{((res.sum)/res.count) >100 ?100:((res.sum)/res.count).toFixed(2)}</span></div>       
        </div>
        <div className="infoResModelEval">             
            {/* <div><span className="txtInfoResModelEval">Evaluación texto.</span></div> 
             <div className="txtResContainer"><span className="calfInfoResModelEvalFin">{resTxt}</span></div>        */} 
        </div>
      </div>
      <div className='containerEvalResGraph'>
      {
      sortedInfoEval.map((evaluator: any) => {
       return (
          <EvalGraphsResults          
            typeEval={evaluator.typeEval}            
            pct={getPesoByTypeEval(evaluator.typeEval)}
            evaluation={evaluator.resultCompetenceIndividual.toFixed(2)}
            evalTxt={convertDesviacionToString(evaluator.result)}
          />
        );  })
      }

      </div>
    </div>
  )
}

export default InfoResultsPerformanceModel
